import React from 'react'
import SuccessPage from '../success'

const SuccessPageDe = () => {
    return <SuccessPage languageCode="de" />
}

export default SuccessPageDe
